module.exports = __webpack_public_path__ + "media/assets/img/ticket/illustration-contact-0bef7a6a3c809cf4a5e67ed84e750fb0.svg";